import classnames from 'classnames';
import styles from './Switch.module.scss';

export default function Switch({ turboStatus = 'disabled', onChange }) {
  return (
    <div className={styles.container}>
      <div 
        onClick={event => onChange('disable')}
        className={classnames(styles.item, {
          [styles.active]: turboStatus === 'disabled'
        })}
      >
        Normal
      </div>
      <div 
        onClick={event => onChange('enable')}
        className={classnames(styles.item, {
          [styles.active]: turboStatus === 'enabled'
        })}
      >
        X Mode
      </div>
    </div>
  )
}
